import axios from 'axios';

import store from '../../store';

function formatErrorResponse(error) {
  const customError = error;
  customError.status = error.response ? error.response.status : null;

  return customError;
}

const defaultHeaders = {
  'Content-Type': 'application/json',
  // eslint-disable-next-line quote-props
  Accept: 'application/json',
};

export default async function api(options) {
  const state = store.getState();
  const authToken = state.oidc.user.access_token;
  const { headers = defaultHeaders, ...otherOptions } = options;

  if (authToken) {
    headers.Authorization = `Bearer ${authToken}`;
  }
  try {
    const result = await axios({ headers, ...otherOptions });
    return result;
  } catch (error) {
    throw formatErrorResponse(error);
  }
}

api.get = (options) => api({ ...options, method: 'GET' });

api.post = (options) => api({ ...options, method: 'POST' });

api.put = (options) => api({ ...options, method: 'PUT' });

api.delete = (options) => api({ ...options, method: 'DELETE' });
